const getters = {
  userName: state => state.user.name,
  jwt: state => state.user.jwt,
  hasPermission: state => state.user.hasPermission,
  permissionList: state => state.user.permissionList,
  screenLoading: state => state.settings.screenLoading,
  uploadImgUrl: state => state.settings.uploadImgUrl,
  uploadFileUrl: state => state.settings.uploadFileUrl
};

export default getters;
